// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimActivityMultiEmployersSummaryRecordDto
 */
export interface IClaimActivityMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityMultiEmployersSummaryRecordDto
     */
    claim_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityMultiEmployersSummaryRecordDto
     */
    claim_status?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityMultiEmployersSummaryRecordDto
     */
    count?: number;
}

/**
 * Check if a given object implements the IClaimActivityMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIClaimActivityMultiEmployersSummaryRecordDto(value: object): value is IClaimActivityMultiEmployersSummaryRecordDto {
    return true;
}

export function IClaimActivityMultiEmployersSummaryRecordDtoFromJSON(json: any): IClaimActivityMultiEmployersSummaryRecordDto {
    return IClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IClaimActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimActivityMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_type': json['claim_type'] == null ? undefined : json['claim_type'],
        'claim_status': json['claim_status'] == null ? undefined : json['claim_status'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function IClaimActivityMultiEmployersSummaryRecordDtoToJSON(json: any): IClaimActivityMultiEmployersSummaryRecordDto {
    return IClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IClaimActivityMultiEmployersSummaryRecordDtoToJSONTyped(value?: IClaimActivityMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_type': value['claim_type'],
        'claim_status': value['claim_status'],
        'count': value['count'],
    };
}

